"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
// Modules
const react_1 = require("react");
const react_redux_1 = require("react-redux");
// Components
const __1 = require("../");
// Icons
const WhatsApp_1 = __importDefault(require("@material-ui/icons/WhatsApp"));
const Facebook_1 = __importDefault(require("@material-ui/icons/Facebook"));
const FileCopy_1 = __importDefault(require("@material-ui/icons/FileCopy"));
// API
const services_1 = require("../../services");
// Styled
const Styled_1 = __importDefault(require("./Styled"));
function ShareModal(props) {
    const testId = `${props.testId}-share-modal`;
    const dispatch = (0, react_redux_1.useDispatch)();
    const facebookMessage = encodeURIComponent(props.message.replace('###UTM###', 'utm_source=fb'));
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURI(props.url)}&quote=${facebookMessage}`;
    const whatsappMessage = encodeURIComponent(props.message.replace('###UTM###', 'utm_source=wpp'));
    const whatsappUrl = `https://api.whatsapp.com/send?text=${whatsappMessage}`;
    const analyticsEvent = (action) => {
        services_1.GoogleAnalyticsService.event({
            event: 'ga-event',
            'event-category': props.analytics.category || 'compartilhar',
            'event-action': 'click',
            'event-label': `${props.analytics.label}:${action}`,
        });
    };
    const shareWhatsApp = () => {
        analyticsEvent('whatsapp');
    };
    const shareFacebook = () => {
        analyticsEvent('facebook');
    };
    const copyLinkToClipboard = () => {
        analyticsEvent('copiar-link');
        const el = document.createElement('textarea');
        el.value = `${props.url}`;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        dispatch({
            type: 'SHOW_TOAST',
            data: { text: 'Link copiado com sucesso!', type: 'success' },
        });
    };
    const closeModal = (0, react_1.useCallback)(() => {
        props.closeModal();
        analyticsEvent('fechar');
    }, [props.analytics.label]);
    if (!props.showModal) {
        return (0, jsx_runtime_1.jsx)("div", {});
    }
    return ((0, jsx_runtime_1.jsx)(Styled_1.default.Wrapper, Object.assign({ "data-testid": testId }, { children: (0, jsx_runtime_1.jsx)(__1.Modal, Object.assign({ testId: testId, showModal: props.showModal, closeModal: closeModal, title: props.title }, { children: (0, jsx_runtime_1.jsxs)(Styled_1.default.Items, { children: [(0, jsx_runtime_1.jsx)(Styled_1.default.ItemsSingle, Object.assign({ "data-testid": `${testId}-whatsapp`, colorIcon: "whatsapp", onClick: shareWhatsApp }, { children: (0, jsx_runtime_1.jsx)("a", Object.assign({ href: whatsappUrl, target: "_blank", rel: "noreferrer noopener", "data-testid": `${testId}-whatsapp-link` }, { children: (0, jsx_runtime_1.jsxs)("dl", { children: [(0, jsx_runtime_1.jsx)("dt", { children: (0, jsx_runtime_1.jsx)(WhatsApp_1.default, {}) }), (0, jsx_runtime_1.jsx)("dd", { children: "Whatsapp" })] }) })) })), (0, jsx_runtime_1.jsx)(Styled_1.default.ItemsSingle, Object.assign({ "data-testid": `${testId}-facebook`, colorIcon: "facebook", onClick: shareFacebook }, { children: (0, jsx_runtime_1.jsx)("a", Object.assign({ href: facebookUrl, target: "_blank", rel: "noreferrer noopener", "data-testid": `${testId}-facebook-link` }, { children: (0, jsx_runtime_1.jsxs)("dl", { children: [(0, jsx_runtime_1.jsx)("dt", { children: (0, jsx_runtime_1.jsx)(Facebook_1.default, {}) }), (0, jsx_runtime_1.jsx)("dd", { children: "Facebook" })] }) })) })), (0, jsx_runtime_1.jsx)(Styled_1.default.ItemsSingle, Object.assign({ "data-testid": `${testId}-copy`, onClick: copyLinkToClipboard }, { children: (0, jsx_runtime_1.jsxs)("dl", { children: [(0, jsx_runtime_1.jsx)("dt", { children: (0, jsx_runtime_1.jsx)(FileCopy_1.default, {}) }), (0, jsx_runtime_1.jsx)("dd", { children: "Copiar Link" })] }) }))] }) })) })));
}
exports.ShareModal = ShareModal;
